import React, { useContext, useState } from 'react';
import { BsPersonCircle } from 'react-icons/bs';
import { FaReceipt } from "react-icons/fa";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import { useNavigate, useParams } from 'react-router-dom';
import STC from '../../../STCLibrary/STCFactory/STCFactory';
import './PortalHeader.css';
import PortalHeaderHamburger from './PortalHeaderHamburger/PortalHeaderHamburger';
import { LogoutAPIs } from '../../../API/LogoutAPIs/LogoutAPIs';
import ApiResponseHandler from '../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import NotificationContext from '../../../STCLibrary/NotificationSystem/NotificationContext';

function PortalHeader({ isParent }) {

    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();
    const routeParam = useParams();
    const [showMenu, setShowMenu] = useState(false);

    const navigateTo = (url) => {
        if (isParent) {
            navigate(url);
        }
    };

    const handleLogOut = () => {
        if (window.confirm('Are you sure you want to logout?')) {

            LogoutAPIs.PostLogout()
            .then((response) => {
                if(response.status === 200 && !response.data.error){
                    navigate('/');
                }
            })
            .catch((err) => {
                ApiResponseHandler(err.response, notificationCtx, navigate)
            })
            
        }
    };

    return (
        <div className='portal-header-row'>
            <div onClick={() => navigate('/' + routeParam.userID)} className='logo'>
                <STC.Logo.Long />
            </div>

            <div onClick={() => navigateTo('/' + routeParam.userID + '/passengers')} className='nav-item'>
                {isParent && <div className='header-item'><h5><FaPersonWalkingLuggage /></h5> <strong>Passengers</strong></div>}
            </div>

            <div onClick={() => navigateTo('/' + routeParam.userID + '/payment-history')} className='nav-item'>
                {isParent && <div className='header-item'><h5><FaReceipt /></h5> <strong>Payments</strong></div>}
            </div>

            <div onClick={() => setShowMenu(!showMenu)} className='nav-item' id='account-menu'>
                {isParent ? (
                    <>
                        <div className='header-item'>
                            <h5><BsPersonCircle /></h5>
                            <div className={showMenu ? 'account-menu active' : 'account-menu'}>
                                <div className='option' onClick={() => navigate('/' + routeParam.userID + '/my-account')}>My Account</div>
                                <div className='option' onClick={handleLogOut}>Logout</div>
                            </div>
                        </div>
                        <div className='hamburger-container'>
                            <PortalHeaderHamburger isParent={isParent} />
                        </div>
                    </>
                )
                : 
                <>
                <div className='header-item ' >
                    <div onClick={handleLogOut} className='log-out-option'>Log Out</div>
                </div>
                <div className='hamburger-container'>
                    <PortalHeaderHamburger isParent={isParent} />
                </div>
                </>
            }
            </div>
        </div>
    );
}

export default PortalHeader;
